import { Alert, AlertTitle, Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const Error401 = () => {
  const navigate = useNavigate()

  return (
    <Alert severity="warning" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height:'calc(100vh - 64px)'}}>
        <AlertTitle>401 Unauthorized</AlertTitle>
        Please login or register
        <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center'}}>
        <Button size="small" color="warning" variant="contained" onClick={() => navigate('/login')} style={{marginRight: '5px', marginTop: '5px'}}>Login</Button>
        <Button size="small" color="warning" variant="contained" onClick={() => navigate('/register')} style={{marginRight: '5px', marginTop: '5px'}}>Register</Button>
        </div>

    </Alert>
  )
}

export default Error401